<template>
  <a-modal
    title="新增"
    :width="500"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :destroyOnClose="true"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-row :gutter="24">
        <a-col :md="24" :sm="24">
          <a-form :form="form">
            <!-- 代理名称 -->
            <a-form-item label="代理名称" :labelCol="labelCol" :wrapperCol="wrapperCol" has-feedback>
              <a-input 
                :max-length="10"
                placeholder="请输入"
                v-decorator="['agentName', { rules: [{ required: true, message: '请输入！' }] }]"
              />
            </a-form-item>
            <!-- 等级 -->
            <a-form-item label="等级" :labelCol="labelCol" :wrapperCol="wrapperCol" has-feedback>
              <a-select 
                v-decorator="['grade', { rules: [{ required: true, message: '请输入！' }] }]"
                allow-clear 
                placeholder="请选择"
              >
                <a-select-option value="V1">V1</a-select-option>
                <a-select-option value="V2">V2</a-select-option>
                <a-select-option value="V3">V3</a-select-option>
                <a-select-option value="V4">V4</a-select-option>
                <a-select-option value="V5">V5</a-select-option>
              </a-select>
            </a-form-item>
            <!-- 营业金额 -->
            <a-form-item label="营业额（万）" :labelCol="labelCol" :wrapperCol="wrapperCol" has-feedback>
              <a-input-number 
                placeholder="请输入"
                :min="0"
                :max="99999999"
                style="width: 50%;min-width: 100px"
                v-decorator="['businessPrice', { rules: [{ required: true, message: '请输入！' }] }]"
              />
            </a-form-item>
            <!-- 营业金额 -->
            <a-form-item label="拉新数" :labelCol="labelCol" :wrapperCol="wrapperCol" has-feedback>
              <a-input-number 
                placeholder="请输入"
                :min="0"
                :max="999999"
                :precision="0"
                style="width: 50%;min-width: 100px"
                v-decorator="['newNumber', { rules: [{ required: true, message: '请输入！' }] }]"
              />
            </a-form-item>
            <!-- 排序 -->
            <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol" has-feedback>
              <a-input-number 
                placeholder="请输入"
                :min="0"
                :max="999999"
                :precision="0"
                style="width: 50%;min-width: 100px"
                v-decorator="['sort', { rules: [{ required: true, message: '请输入！' }] }]"
              />
            </a-form-item>
          </a-form>
        </a-col>
      </a-row>
    </a-spin>
  </a-modal>
</template>

<script>
import { 
  agentGradeAdd
} from '@/api/modular/mallLiving/agentGrade'

export default {
  data() {
    return {
      loading: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
    }
  },

  methods: {
    // 初始化方法
    add() {
      this.visible = true
    },
    handleSubmit() {
      this.confirmLoading = true
      this.form.validateFields((errors, values) => {
        if (!errors) {
            agentGradeAdd(values).then((res) => {
              if(res.success){
                this.$message.success("新增成功！")
                this.$emit("ok",values)
                this.confirmLoading = false
                this.handleCancel()
              }else{
                setTimeout(()=>{
                  this.confirmLoading = false
                }, 600)
              }
            })
        } else {
          this.confirmLoading = false
        }
      })
    },
    handleCancel() {
      this.visible = false //关闭对话框
      this.confirmLoading = false
      this.form.resetFields() //重置表单
    }
  },
}
</script>
<style scoped>
.flex {
  display: flex;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>